import { render } from "./home.vue?vue&type=template&id=ddfea610&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=ddfea610&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddfea610"]])

export default __exports__